import React, {useContext} from 'react'
import { NavLink } from 'react-router-dom'
import { MouseContext } from "../../context/mouseContext"
import './menu.css'

const handleClick = () =>{
    document.querySelector('.menu-overlay').classList.toggle('active');
    document.querySelector('.menu').classList.toggle('active');
    document.querySelector('.all').classList.toggle('active');
}


const Menu = () => {
    const {  cursorChangeHandler } = useContext(MouseContext);
    return (
        <div id="menu" className="menu d-flex justify-content-center align-items-center columns">
            <div className="d-grid menu-content text-white">
                <div className="">
                    <ul className="mb-0 list-unstyled">
                        <li><h1>
                            <NavLink 
                                to='/'
                                onMouseEnter={() => cursorChangeHandler("hovered")}
                                onMouseLeave={() => cursorChangeHandler("")}
                                onClick ={handleClick} >Home
                            </NavLink>
                        </h1></li>
                    </ul>
                </div>
                <div>
                    <ul className="mb-0 list-unstyled">
                        <li><h1>
                            <NavLink 
                                to='/about'
                                onClick ={handleClick} 
                                onMouseEnter={() => cursorChangeHandler("hovered")}
                                onMouseLeave={() => cursorChangeHandler("")}
                                >about
                                
                            </NavLink>
                        </h1></li>
                    </ul>
                </div>

                <div>
                    <ul className="mb-0 list-unstyled">
                        <li><h1>
                            <NavLink 
                                to='/services'
                                onMouseEnter={() => cursorChangeHandler("hovered")}
                                onMouseLeave={() => cursorChangeHandler("")}
                                onClick ={handleClick} >services
                            </NavLink>
                        </h1></li>
                    </ul>
                </div>

                <div>
                    <ul className="mb-0 list-unstyled">
                        <li><h1>
                            <NavLink 
                                to='/projects'
                                onMouseEnter={() => cursorChangeHandler("hovered")}
                                onMouseLeave={() => cursorChangeHandler("")}
                                onClick ={handleClick} >projects
                            </NavLink>
                        </h1></li>
                    </ul>
                </div>

                <div>
                    <ul className="mb-0 list-unstyled">
                        <li className='d-md-none d-block'><h1>
                            <NavLink 
                                to='/contact'
                                onMouseEnter={() => cursorChangeHandler("hovered")}
                                onMouseLeave={() => cursorChangeHandler("")}
                                className="small-links "
                                onClick ={handleClick} >contact
                            </NavLink>
                        </h1></li>
                        <li className='d-md-block d-none'><h1>contact</h1></li>
                        <li className="small-links d-md-block d-none">
                            <ul className="mb-0 mx-1 list-unstyled">
                                <li className='py-1'>40366, Abu Dhabi, UAE</li>
                                <li className='py-1'>+97126714044</li>
                                <li className='py-1'>+971509427330</li>
                                <li className='py-1'><a href="mailto:info@macline.online">info@macline.online</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Menu